import { getApiConfig } from '../utils/apiUtils';
import axios from 'axios';

const API_BASE = '/distribution/api/channel-inventories';

export const fetchAllChannelInventories = async (filters = {}) => {
  const params = new URLSearchParams();
  if (filters.channel_id) params.append('channel_id', filters.channel_id);
  if (filters.room_type_id) params.append('room_type_id', filters.room_type_id);
  
  const url = params.toString() ? `${API_BASE}/?${params.toString()}` : `${API_BASE}/`;
  const response = await axios.get(url, getApiConfig());
  return response.data;
};

export const fetchChannelInventoryById = async (inventoryId) => {
  const response = await axios.get(`${API_BASE}/${inventoryId}/`, getApiConfig());
  return response.data;
};

export const createChannelInventory = async (inventoryData) => {
  const response = await axios.post(`${API_BASE}/`, inventoryData, getApiConfig());
  return response.data;
};

export const updateChannelInventory = async (inventoryId, inventoryData) => {
  const response = await axios.put(`${API_BASE}/${inventoryId}/`, inventoryData, getApiConfig());
  return response.data;
};

export const deleteChannelInventory = async (inventoryId) => {
  const response = await axios.delete(`${API_BASE}/${inventoryId}/`, getApiConfig());
  return response.data;
};

